import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { Menu } from 'lucide-react';
interface LayoutProps {
  children: React.ReactNode;
  activePage: string;
  onNavigate: (page: string) => void;
}
export function Layout({
  children,
  activePage,
  onNavigate
}: LayoutProps) {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  return <div className="flex h-screen bg-stone-50 overflow-hidden" data-id="element-27">
      <Sidebar activePage={activePage} onNavigate={onNavigate} isMobileOpen={isMobileOpen} setIsMobileOpen={setIsMobileOpen} data-id="element-28" />

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden" data-id="element-29">
        {/* Mobile Header */}
        <header className="md:hidden flex items-center justify-between px-4 h-16 bg-white border-b border-stone-200 flex-shrink-0" data-id="element-30">
          <div className="flex items-center gap-2" data-id="element-31">
            <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center text-white font-bold text-lg" data-id="element-32">
              A
            </div>
            <span className="font-bold text-lg text-stone-900" data-id="element-33">Attend</span>
          </div>
          <button onClick={() => setIsMobileOpen(true)} className="p-2 text-stone-600 hover:bg-stone-100 rounded-lg" data-id="element-34">
            <Menu size={24} data-id="element-35" />
          </button>
        </header>

        {/* Main Content */}
        <main className="flex-1 overflow-y-auto p-4 md:p-8" data-id="element-36">
          <div className="max-w-6xl mx-auto" data-id="element-37">{children}</div>
        </main>
      </div>
    </div>;
}